export default __webpack_public_path__ + "static/66ec922a021c4b8ed537c63c67a3f8fe.png";